export default {
  properties: {
    allow_multiple: { type: 'boolean' },
  },
};
